import { render, staticRenderFns } from "./DetalheNovosClientesFaturado.vue?vue&type=template&id=3451a508&scoped=true&"
import script from "./DetalheNovosClientesFaturado.vue?vue&type=script&lang=js&"
export * from "./DetalheNovosClientesFaturado.vue?vue&type=script&lang=js&"
import style0 from "./DetalheNovosClientesFaturado.vue?vue&type=style&index=0&id=3451a508&scoped=true&lang=css&"
import style1 from "./DetalheNovosClientesFaturado.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451a508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VIcon,VRow,VTooltip})
